import { Assistance } from './assistance';
import { AssistancePlan } from './assistance-plan';
import { Sponsor } from './sponsor';



export const ASSISTANCE_COVER_LETTER_STATUSES_TEXT:any = {
  0: 'Hidden',
  1: 'Active'
};


export class AssistanceCoverLetter {
  id: number;
  name: string;
  product_id: number;
  plan_id: number;
  sponsor_id: number;
  date_start: string;
  date_end: string;
  status: number;
  assistanceplan:AssistancePlan = new AssistancePlan();
  plan:AssistancePlan;
  product:Assistance = new Assistance();
  sponsor:Sponsor;
}
